
import { Progress } from "@/components/ui/progress";

interface ProgressIndicatorProps {
  currentIndex: number;
  totalQuestions: number;
  progress: number;
}

const ProgressIndicator = ({ currentIndex, totalQuestions, progress }: ProgressIndicatorProps) => {
  return (
    <div className="mb-4 md:mb-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs md:text-sm font-medium text-foreground">Progress</span>
        <span className="text-xs md:text-sm text-muted-foreground">{Math.round(progress)}% complete</span>
      </div>
      <Progress value={progress} className="h-2 md:h-3 mb-3 md:mb-4" />
      
      {/* Step indicators */}
      <div className="flex justify-between px-1">
        {Array.from({ length: totalQuestions }, (_, index) => (
          <div
            key={index}
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-200 ${
              index < currentIndex
                ? "bg-green-500 scale-110"
                : index === currentIndex
                ? "bg-primary scale-125"
                : "bg-muted"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
